import { colors } from '@shared/tokens/colors.stylex';

export const UploadIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.55806 2.05806C9.80214 1.81398 10.1979 1.81398 10.4419 2.05806L14.1919 5.80806C14.436 6.05214 14.436 6.44786 14.1919 6.69194C13.9479 6.93602 13.5521 6.93602 13.3081 6.69194L10.625 4.00888L10.625 13.75C10.625 14.0952 10.3452 14.375 10 14.375C9.65482 14.375 9.375 14.0952 9.375 13.75L9.375 4.00888L6.69194 6.69194C6.44786 6.93602 6.05214 6.93602 5.80806 6.69194C5.56398 6.44786 5.56398 6.05214 5.80806 5.80806L9.55806 2.05806ZM2.5 13.125C2.84518 13.125 3.125 13.4048 3.125 13.75V15.625C3.125 16.3154 3.68464 16.875 4.375 16.875H15.625C16.3154 16.875 16.875 16.3154 16.875 15.625V13.75C16.875 13.4048 17.1548 13.125 17.5 13.125C17.8452 13.125 18.125 13.4048 18.125 13.75V15.625C18.125 17.0057 17.0057 18.125 15.625 18.125H4.375C2.99429 18.125 1.875 17.0057 1.875 15.625V13.75C1.875 13.4048 2.15482 13.125 2.5 13.125Z"
        fill={colors.primaryText}
      />
    </svg>
  );
};
